import {IDataGridMadel} from "../../model";
import {createGetProps} from "./helpers";
import {api, apiStatic, checkEs6AndRun, requestError} from "../../../helpers";
import {notifyRequestResult} from "../../../../store/modules/notify";
import * as dynamic from 'utils/dynamic';


export const requestSwapPath = (url: string, method: 'patch' | 'put', data: any) => {
  return apiStatic.request({url: checkEs6AndRun(url, data), method, data})
};

export const requestSwap = async (
  {
    model,
    sortable,
    filters,
    onTasks,
    dispatch,
    payload
  }: {
    model: IDataGridMadel,
    sortable: any;
    filters: any;
    onTasks: any;
    dispatch: any;
    payload: { currentRow: any, targetRow: any }
  }) => {
  // params get requests
  const params = createGetProps({model, pagination: {page: 1, size: 1}, filters, sortable});

  const mainField = model.store.mainField;
  const swapField = model.store.swap?.field ?? '';

  // patch method
  onTasks([
    ['onHandle', {type: 'swapStart', params: {...params}, payload: {...payload}}],
    ['loading', true]
  ]);

  try {
    // get current row and target row
    const { data: { value: rows } } = await api.request({
      url: params.url,
      method: 'post',
      data: {
        Select: dynamic.select(mainField, swapField),
        Filter: dynamic.mergeFilters(
          dynamic.makeFilter(mainField, [payload.currentRow[mainField], payload.targetRow[mainField]], dynamic.decoratorValueArray(dynamic.equals))
        ).join('&&'),
        Take: 2
      }
    })
    if (rows.length !== 2) {
      throw new Error('Invalid rows');
    }

    // flip rank
    const firstRow = rows[0];
    const rankFirstRow = firstRow[swapField];

    const secondRow = rows[1];
    const rankSecondRow = secondRow[swapField];

    firstRow[swapField] = rankSecondRow;
    secondRow[swapField] = rankFirstRow;
    // end flip rank

    const promises = [firstRow, secondRow].map((row) => {
      return requestSwapPath(String(model.store.patch?.url), model.store.patch?.method ?? 'patch', row)
    })

    await Promise.all(promises);

    dispatch({type: 'SOURCES_UPDATE', path: params.url});
    onTasks([
      ['onHandle', {type: 'swapDone', params: {...params}, payload: {...payload}}],
      ['getData'],
    ]);


  } catch (error) {
    onTasks([
      ['onHandle', {type: 'getError', error: error}],
      ['loading', false]
    ]);
    dispatch(notifyRequestResult(requestError(error), 'error'));
    console.error(error);
    return;
  }
};
